module.exports = __webpack_public_path__ + "img/zhlc-3.1375267e.png";